import React, {Fragment, useMemo, useState} from "react";
import CustomSearch from "@pages/components/CustomSearch";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";
import InvoicesTable from "@pages/components/DebtManagement/CustomerOverview/InvoicesTable";
import {GET_CUSTOMER_DEBT_REQUEST} from "@redux/Customer/actions";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import axios from "axios";
import notify from "@utils/notify";
import {API_URL} from "@constants/index";

export default function DebtListComponent({ activeTab, customerId}) {
    const {
        customerDebts
    } = useSelector((state) => state.customer, shallowEqual);
    const dispatch = useDispatch()

    const [filter,setFilter] = useState({});

    const returnDebts = (invoicesList) => {
        return  invoicesList.filter(debt=> {
            return  new Date(debt.due_date) < new Date();
        })
    }

    const debtsData = useMemo(()=> {
        const tDebts = customerDebts.customer_debt;
        return activeTab === 'invoices' ? tDebts : returnDebts(tDebts)
    },[activeTab,customerDebts])
    
    const updateFilter = ({key,value}) => {
        let overviewTemp = {...filter}
        overviewTemp[key] = value
        setFilter(overviewTemp)
        fetchDebts(overviewTemp)
    }
    const setOrderItem = (data) =>{
        let tempFilter = {...filter,...data}
        setFilter(tempFilter)
        fetchDebts(tempFilter)
    }
    const fetchDebts = (tempFilter = {}) => {
        dispatch({
            type: GET_CUSTOMER_DEBT_REQUEST,
            payload: { id: customerId, filter: tempFilter }
        });
    }
    const keys = [
        { key: 'xero_invoice_number', label: 'Number/Type' },
        { key: 'reference', label: 'Reference' },
        { key: 'issue_date', label: 'Issue date', sort: true },
        { key: 'due_date', label: 'Due date', sort: true },
        { key: 'paid_date', label: 'Paid date' },
        { key: 'total', label: 'Total' },
        { key: 'amount_due', label: 'Due' },
        { key: 'invoice_status', label: 'Status' },
        { key: 'sent', label: 'Sent' },
        { key: 'view', label: 'View' },
    ];

    const viewDetails = (id) => {

        axios({
            method: 'GET',
            url: API_URL + `/show-invoice/${1}`,
            params: {
                id
            }
        })
            .then(response => {
                if (response.status === 200) {
                    let data = response.data;
                    let invoice = data.data.invoice;
                    if (invoice) {
                        window.open(invoice, "_blank");
                    } else {
                        notify.warning('Invoice is empty')
                    }
                }
            })
            .catch(error => {
                console.error('error :: ', error.response);

            })
    }
   return (
       <>

           <div className='d-flex flex-column flex-md-row g-10 mb-3'>
               <div className='flex-grow-1'>
                   <CustomSearch
                       type="text"
                       placeholder="Enter an amount, reference, or invoice number"
                       inputWidth={'100%'}
                       onChange={(e) => updateFilter({key:'search',value:e.target.value})}
                   />
               </div>

           </div>
           <div>
                   <InvoicesTable viewDetails={viewDetails} keys={keys} tableData={debtsData} filter={filter} setOrderItem={setOrderItem}/>
           </div>
       </>

   )
}